module.exports = __webpack_public_path__ + "assets/imgs/gmp/gmp-searchAds.112b3e0f3080972d0afef07fa44057e1.png";